const keyTheme: string = "theme-store";
const keyColumnVisibility: string = "column-visibility-store";

export { keyTheme, keyColumnVisibility };
